<template>
  <div class="u-bg--white not-found">
    <breadcrumb :text="'Page non trouvée'" class="u-color--grey-dark"/>

    <div class="u-align--center">
      <h1>Page non trouvée...</h1>
      <simple-title :text="'La page que vous demandez n’existe pas.'"/>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from "./Breadcrumb";
  import SimpleTitle from "./SimpleTitle";
  export default {
    name: "NotFoundParagraph",
    components: {SimpleTitle, Breadcrumb}
  }
</script>

<style lang="scss">
  .not-found {
    padding: rem(30px) rem(135px);

    @include mq($until: MD) {
      padding: rem(10px);
    }

    h1 {
      font-size: rem(46px);
      line-height: rem(36px);

      @include mq($until: MD) {
        font-size: rem(30px);
      }
    }

    .simpleTitle {
      font-weight: 300;
    }
  }
</style>